module.exports = __webpack_public_path__ + "media/promo/velle/images/recipes/recipe_1-5884a120338d4a9dc2f444f76f43e46e.jpg";